module.exports = __webpack_public_path__ + "img/placeholder.8057445e.png";